import { useTranslate } from "hooks/useTranslate";
import type React from "react";

type TranslationHelpersReturn = {
  PROJECT_EDITED_BY: (fullName: string) => string | React.ReactElement;
  UNKNOWN: string | React.ReactElement;
  SHARED: string | React.ReactElement;
  NOT_SHARED: string | React.ReactElement;
  PROJECT_STATUS_UPDATE: string | React.ReactElement;
  DOWNLOAD: string | React.ReactElement;
  DUPLICATE: string | React.ReactElement;
  SHARE: string | React.ReactElement;
  DELETE: string | React.ReactElement;
  DETAILS: string | React.ReactElement;
  PROJECT_MODAL_DELETE_TEXT: string | React.ReactElement;
  PROJECT_MODAL_DELETE_WARNING_TEXT_WITH_TITLE: (
    title: string,
  ) => string | React.ReactElement;
  PROJECT_LIST_LAST_MODIFICATION: string | React.ReactElement;
  PROJECT_LIST_PROJECT: string | React.ReactElement;
  ERROR_OCCURED: string | React.ReactElement;
  PROJECT_LIST_NO_DATA: string | React.ReactElement;
  PROJECT_LIST_STATUS: string | React.ReactElement;
  PROJECT_SHARING_SETTINGS: string | React.ReactElement;
};

export const useTranslationHelpers = (): TranslationHelpersReturn => {
  const translate = useTranslate();
  return {
    PROJECT_EDITED_BY: (fullName: string) =>
      translate("PROJECT_EDITED_BY", fullName || translate("UNKNOWN")),
    UNKNOWN: translate("UNKNOWN"),
    SHARED: translate("SHARED"),
    NOT_SHARED: translate("NOT_SHARED"),
    PROJECT_STATUS_UPDATE: translate("PROJECT_STATUS_UPDATE"),
    DOWNLOAD: translate("DOWNLOAD"),
    DUPLICATE: translate("DUPLICATE"),
    SHARE: translate("SHARE"),
    DELETE: translate("DELETE"),
    DETAILS: translate("DETAILS"),
    PROJECT_MODAL_DELETE_TEXT: translate("PROJECT_MODAL_DELETE_TEXT"),
    PROJECT_MODAL_DELETE_WARNING_TEXT_WITH_TITLE: (title: string) =>
      translate("PROJECT_MODAL_DELETE_WARNING_TEXT_WITH_TITLE", title),
    PROJECT_LIST_LAST_MODIFICATION: translate("PROJECT_LIST_LAST_MODIFICATION"),
    PROJECT_LIST_PROJECT: translate("PROJECT_LIST_PROJECT"),
    ERROR_OCCURED: translate("ERROR_OCCURED"),
    PROJECT_LIST_NO_DATA: translate("PROJECT_LIST_NO_DATA"),
    PROJECT_LIST_STATUS: translate("PROJECT_LIST_STATUS"),
    PROJECT_SHARING_SETTINGS: translate("PROJECT_SHARING_SETTINGS"),
  };
};
